import React, { useEffect, useState } from"react";
import { useParams } from"react-router-dom";
import axios from"axios";
import AddQuestionForm from"./AddQuestionForm";
import EditQuestionForm from"./EditQuestionForm";
import API_BASE_URL from"../Config/config";

const TrackQuestionPage = () => {
 const { track } = useParams();
 const [questions, setQuestions] = useState([]);
 const [editing, setEditing] = useState(null);
 const [loading, setLoading] = useState(true); // ✅ New loading state

 // ✅ Fetch questions on load
 useEffect(() => {
 setLoading(true); // Start loading
 axios
 .get(`${API_BASE_URL}/sgl-tables/${track}`)
 .then((res) => {
 setQuestions(res.data);
 setLoading(false);
 })
 .catch((err) => {
 console.error("Failed to fetch questions", err);
 setLoading(false);
 });
 }, [track]);

 // ✅ Delete question by ID
 const handleDelete = async (id) => {
 try {
 await axios.delete(`${API_BASE_URL}/sgl-tables/${track}/question/${id}`);
 setQuestions((prev) => prev.filter((q) => q.id !== id));
 } catch (err) {
 console.error("Delete failed:", err);
 }
 };

 // ✅ Start editing
 const handleEdit = (question) => {
 setEditing(question);
 };

 // ✅ Append new question to UI
 const handleAdd = (newQuestion) => {
 setQuestions((prev) => [...prev, newQuestion]);
 };

 // ✅ Update question after edit
 const handleUpdate = (updatedQ) => {
 setQuestions((prev) =>
 prev.map((q) => (q.id === updatedQ.id ? updatedQ : q))
 );
 setEditing(null);
 };

 return (
 <div className="bg-bgMain min-h-screen text-white px-6 py-10">
 <div className="text-3xl font-bold text-primary mb-6">
 All Coding Questions - {track}
 </div>

 {/* Add Form */}
 <AddQuestionForm onAdd={handleAdd} track={track} />

 {/* Edit Form */}
 {editing && (
 <EditQuestionForm
 question={editing}
 track={track}
 onUpdate={handleUpdate}
 onClose={() => setEditing(null)}
 />
 )}

 {/* Content */}
 {loading ? (
 <div className="text-primary font-medium">Loading questions...</div>
 ) : questions.length === 0 ? (
 <div className="text-muted">No questions found for this track.</div>
 ) : (
 questions.map((q, idx) => (
 <div
 key={q.id || idx}
 className="bg-[#1a1a1a] p-6 mb-6 rounded-xl shadow-md relative"
 >
 <div className="text-lg font-semibold text-primary mb-2">
 {idx + 1}. {q.question}
 </div>
 <div className="ml-4 text-sm leading-6 text-white">
 <div>A. {q.option_a}</div>
 <div>B. {q.option_b}</div>
 <div>C. {q.option_c}</div>
 <div>D. {q.option_d}</div>
 </div>

 <div className="absolute top-4 right-4 space-x-2">
 <button
 onClick={() => handleEdit(q)}
 className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
 >
 Edit
 </button>
 <button
 onClick={() => handleDelete(q.id)}
 className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
 >
 Delete
 </button>
 </div>
 </div>
 ))
 )}
 </div>
 );
};

export default TrackQuestionPage;



